import { z } from 'zod'

const optionalText = z.string().trim().optional()
const optionalDate = z.string().regex(/^(\d{4}-\d{2}-\d{2})?$/, 'Datum im Format JJJJ-MM-TT').optional()

export const createEquipmentSchema = z.object({
  name: z.string().trim().min(1, 'Gerätename ist erforderlich'),
  category: z.string().min(1, 'Kategorie ist erforderlich'),
  manufacturer: optionalText,
  model: optionalText,
  serialNumber: optionalText,
  purchaseDate: optionalDate,
  purchasePrice: z.string().trim().regex(/^(\d+([.,]\d{1,2})?)?$/, 'Preis z.B. 349,90').optional(),
  warrantyUntil: optionalDate,
  supplier: optionalText,
  invoiceNumber: optionalText,
  dguvIntervalMonths: z.number().int().min(0, 'Mindestens 0').max(60, 'Höchstens 60').optional(),
  dguvNextCheck: optionalDate,
  notes: optionalText,
})

export type CreateEquipmentInput = z.infer<typeof createEquipmentSchema>
